import { ActionTypes } from './actions';

const defaultState = {};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.CLICK_NEXT_ANIMATION_START:
        case ActionTypes.CLICK_PREV_ANIMATION_START:
            return {
                ...state,
                animationNextLocationId: action.locationId,
                callbackAfterAnimationCompletes: action.callbackAfterAnimationCompletes,
            };
        case ActionTypes.SET_LOCATION:
        case ActionTypes.CLICK_NEXT:
        case ActionTypes.CLICK_PREV:
            return {
                ...state,
                locationId: action.locationId,
                animationNextLocationId: action.locationId,
            };

        default:
            return state;
    }
};
